// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type { BaseResponseAgentConfigFoundResponse, PostAgentConfigsBody } from '../types';

/**
 * findByCompanyId
 *
 * @export
 * @tags agent-config-controller
 * @link [GET] /agentConfigs
 */
export function getAgentConfigs(): Promise<BaseResponseAgentConfigFoundResponse>;
export function getAgentConfigs(
    options: ApiOptions<never, never>
): Promise<BaseResponseAgentConfigFoundResponse>;
export function getAgentConfigs(
    options?: ApiOptions<never, never>
): Promise<BaseResponseAgentConfigFoundResponse> {
    return request<never, never, never>('/agentConfigs', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAgentConfigs',
    });
}

/**
 * save
 *
 * @export
 * @tags agent-config-controller
 * @link [POST] /agentConfigs
 */
export function postAgentConfigs(
    data: PostAgentConfigsBody
): Promise<BaseResponseAgentConfigFoundResponse>;
export function postAgentConfigs(
    data: PostAgentConfigsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseAgentConfigFoundResponse>;
export function postAgentConfigs(
    data: PostAgentConfigsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseAgentConfigFoundResponse> {
    return request<PostAgentConfigsBody, never, never>('/agentConfigs', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postAgentConfigs',
    });
}

export const meta = [
    { tags: ['agent-config-controller'], path: '/agentConfigs', method: 'get' },
    { tags: ['agent-config-controller'], path: '/agentConfigs', method: 'post' },
];
